export default "__VITE_ASSET__BYkt4ju5__"